import React from 'react';
import Tooltip from '../Tooltip';
import Icon from '../Icon';

export const OrganisationSettingsSectionHeader = ({ title, tooltip }) => {
  return (
    <div className="organisation-settings__section-header">
      <h2 className="organisation-settings__section-title">
        {title}
        {tooltip && (
          <Tooltip tooltip={tooltip}>
            <span>
              <Icon
                className="organisation-settings__section-title-icon"
                kind="info-circle"
              />
            </span>
          </Tooltip>
        )}
      </h2>
    </div>
  );
};
